import 'whatwg-fetch'
const env = process.env;

const getPgus = (params) => {
  return fetch(`${env.VUE_APP_trimaster}/api/v1/zoneDevices?${params}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getPlatformGroupDevices = (params) => {
  return fetch(`${env.VUE_APP_trimaster}/api/v1/devices/getPlatformGroupDevices?platformGroup_id=${params.platformGroup_id}&access_token=${params.apitoken}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getTempetatureChartData = (params) => {
  return fetch(`${env.VUE_APP_trimaster}/api/v1/temperatureSensorHistories/getChartData?startDate=${params.startDate}&endDate=${params.endDate}&interval=${params.interval}&device_id=${params.deviceId}&start=${params.start}&limit=${params.limit}&access_token=${params.apitoken}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getHumidityChartData = (params) => {
  return fetch(`${env.VUE_APP_trimaster}/api/v1/humiditySensorHistories/getChartData?startDate=${params.startDate}&endDate=${params.endDate}&interval=${params.interval}&device_id=${params.deviceId}&start=${params.start}&limit=${params.limit}&access_token=${params.apitoken}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getCo2ChartData = (params) => {
  return fetch(`${env.VUE_APP_trimaster}/api/v1/co2SensorHistories/getChartData?startDate=${params.startDate}&endDate=${params.endDate}&interval=${params.interval}&device_id=${params.deviceId}&start=${params.start}&limit=${params.limit}&access_token=${params.apitoken}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getZoneDevice = (params) => {
  return fetch(`${env.VUE_APP_trimaster}/api/v1/zoneDevices/${params.id}?access_token=${params.apitoken}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getIrrigationZone = (params) => {
  let filter = {
    "where":{
      "zonetype_id":1,
      "facility_id":params.facility_id
    }
  }

  return fetch(`${env.VUE_APP_trimaster}/api/v1/zones?filter=${encodeURIComponent(JSON.stringify(filter))}&access_token=${params.apitoken}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getCO2Zone = (params) => {
  let filter = {
    "where":{
      "zonetype_id":2,
      "facility_id":params.facility_id
    }
  }

  return fetch(`${env.VUE_APP_trimaster}/api/v1/zones?filter=${encodeURIComponent(JSON.stringify(filter))}&access_token=${params.apitoken}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getGrowZone = (params) => {
  let filter = {
    "where":{
      "zonetype_id":3,
      "facility_id":params.facility_id
    }
  }

  return fetch(`${env.VUE_APP_trimaster}/api/v1/zones?filter=${encodeURIComponent(JSON.stringify(filter))}&access_token=${params.apitoken}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getWorkZone = (params) => {
  let filter = {
    "where":{
      "zonetype_id":4,
      "facility_id":params.facility_id
    }
  }

  return fetch(`${env.VUE_APP_trimaster}/api/v1/zones?filter=${encodeURIComponent(JSON.stringify(filter))}&access_token=${params.apitoken}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

export default {
  getPgus,
  getPlatformGroupDevices,
  getTempetatureChartData,
  getHumidityChartData,
  getCo2ChartData,
  getZoneDevice,
  getIrrigationZone,
  getCO2Zone,
  getGrowZone,
  getWorkZone,
}
